import { z } from "zod";

/**
 * Başarısız giriş koruması ve hesap kilidi (CLOS-236 `[081]`).
 *
 * ### ⚠ Kilit bir SİLAH olmamalı
 *
 * CLOS-214 `[080]`: *"kolay DoS veya HESAP KİLİTLEME ARACINA dönüşmez."* Kalıcı kilit,
 * saldırgana kurbanın hesabını istediği zaman kapatma gücü verirdi — birinin e-postasını
 * bilmek, onu sistemden atmaya yetmemeli. Bu yüzden kilit her zaman SÜRELİ ve kendiliğinden
 * açılıyor; süre tekrarlanan saldırıda kademeli uzuyor.
 *
 * ### ⚠ Kilit CEVABI DEĞİŞTİRMİYOR
 *
 * Kart: *"hesap varlığı hata mesajından ifşa edilmez."* "Hesabınız kilitli" deseydik, o
 * cümle hesabın VAR olduğunun kanıtı olurdu ve kilit mekanizması bir hesap sayım aracına
 * dönerdi. Kilitliyken doğru parola bile oturum açmıyor ama kullanıcı yanlış paroladakiyle
 * AYNI cevabı görüyor.
 */
export const loginProtectionConfigSchema = z.object({
  /** Başarısızlıkların sayıldığı pencere; bu süre boyunca deneme yoksa sayaç sıfırlanır. */
  windowMinutes: z.number().int().positive(),
  /**
   * KADEMELER — eşik aşıldıkça kilit uzuyor.
   *
   * Tek bir eşik olsaydı, ısrarlı bir saldırgan her 15 dakikada bir 4 deneme yaparak
   * sınırsız denemeye devam ederdi. Kademe, ısrarın maliyetini artırıyor.
   */
  steps: z
    .array(
      z.object({
        failures: z.number().int().positive(),
        lockMinutes: z.number().int().positive(),
      }),
    )
    .min(1),
});
export type LoginProtectionConfig = z.infer<typeof loginProtectionConfigSchema>;

/**
 * Verilen başarısızlık sayısına karşılık gelen kilit süresi; eşik aşılmadıysa `0`.
 *
 * En YÜKSEK aşılan kademe kazanıyor: sıralamaya güvenmek yerine hepsine bakıyoruz, çünkü
 * konfigürasyonun sıralı yazıldığı bir varsayım ve o varsayım bir gün bozulur.
 */
export function lockMinutesFor(config: LoginProtectionConfig, failures: number): number {
  let sonuc = 0;
  for (const adim of config.steps) {
    if (failures >= adim.failures && adim.lockMinutes > sonuc) sonuc = adim.lockMinutes;
  }
  return sonuc;
}
